const isInvalid = (touched, errors, field) =>
  Boolean(touched[field.name] && errors[field.name]);

export default isInvalid;
